<template>
  <div
    id="small-calendar"
    class="px-4 pb-4 vuetify slim-scroll"
  >
    <div class="d-flex justify-content-center text-info align-items-center">
      <i
        class="fas text-secondary pointer-on-hover p-2 fa-chevron-left"
        @click="$refs.calendar.prev()"
      />
      <div class="py-4 text-secondary">
        <h4 class="mx-2">
          {{ months[Number(value.split('-')[1]) - 1] }} de {{ value.split('-')[0] }}
        </h4>
      </div>
      <i
        class="fas text-secondary pointer-on-hover p-2 fa-chevron-right"
        @click="$refs.calendar.next()"
      />
    </div>
    <v-sheet height="400">
      <v-calendar
        ref="calendar"
        v-model="value"
        class="border-bottom border-right"
        :weekdays="weekday"
        :type="type"
        :events="eventsCycleTimed"
        :event-overlap-mode="mode"
        :event-overlap-threshold="30"
        :event-color="getEventColor"
        :event-category="getEventCategory"
      />
    </v-sheet>
  </div>
</template>

<script>

import {months} from "../../../constants/months";
import {getEventCategory, getEventColor, data as DataObject} from "../../../common/utils/calendarHelpers";
import {mapActions, mapGetters} from "vuex";

export default {

  data: () => ({
    ...DataObject,
    months,
    type: 'week',
    mode:'column'
  }),
  computed:{
    ...mapGetters([
      'eventsCycleTimed'
    ])
  },
  created() {
    this.getEvents();
    this.value = this.$moment().format('Y-MM-DD')
  },
  methods: {
    ...mapActions([
      'getEvents'
    ]),
    getEventColor,
    getEventCategory,
  },
}
</script>
<style lang="scss">
  #small-calendar{
    .v-btn--fab.v-size--default {
      height: 33px;
      width: 33px;
    }
    .v-event-timed{
      &:hover{
        white-space: normal;
        height: 100%!important;
      }
    }
  }

</style>
